import { Component, ChangeDetectorRef, Input, ChangeDetectionStrategy } from '@angular/core';
import { UnitsService } from '../../shared/services/units-service';
import { CategoriesService } from '../../shared/services/categories-service';
import { IngredientsService } from '../../shared/services/ingredints-service';
import { HttpClient } from '@angular/common/http';
import { EnvironmentUrl } from '../../shared/services/environment-url';
import { UnitsModel } from '../../_interfaces/units';
import { CategoriesModel } from '../../_interfaces/Categories';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { IngredientModel } from '../../_interfaces/ingredient';
import { RecipeModel, RecipeCreateUpdateModel } from '../../_interfaces/recipe';
import { ResipesService } from '../../shared/services/resipes-service';
import { IngredientsModel } from '../../_interfaces/ingredients';
import { EditorModule } from '@openng/optimus-ui/editor';
import { CardModule } from '@openng/optimus-ui/card';
import { TableModule } from '@openng/optimus-ui/table';
import { ButtonModule } from '@openng/optimus-ui/button';
import { SelectModule } from '@openng/optimus-ui/select';
import { Router } from '@angular/router';

@Component({
  selector: 'app-edit-resibe',
  imports: [
    TableModule,
    ButtonModule,
    FormsModule,
    SelectModule,
    CommonModule,
    EditorModule,
    CardModule,
  ],
  templateUrl: './edit-recipe.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './edit-recipe.css',
})
export class EditRecipe {
  @Input() id!: number;
  resibesService?: ResipesService;
  unitsService?: UnitsService;
  categoriesService?: CategoriesService;
  ingredientsService?: IngredientsService;
  types: UnitsModel[] = [];
  categories: CategoriesModel[] = [];
  ingredients: IngredientModel[] = [];
  categoryId: number = -1;
  data: RecipeModel = {
    id: -1,
    name: '',
    oventimeS: 0,
    timeSpentInKichenS: 0,
    cooktimeS: 0,
    totalTimeS: 0,
    description: '',
    endDescription: '',
    servings: 0,
    servings2: 0,
    servingsNode: '',
    category: null,
    ingredients: [],
  };

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private http: HttpClient,
    private envUrl: EnvironmentUrl,
    private router: Router,
  ) {
    this.resibesService = new ResipesService(this.http, this.envUrl);
    this.categoriesService = new CategoriesService(this.http, this.envUrl);
    this.categoriesService.list().subscribe((res) => {
      this.categories = res as CategoriesModel[];
      this.changeDetectorRef.detectChanges();
    });
    this.unitsService = new UnitsService(this.http, this.envUrl);
    this.unitsService.list().subscribe((res) => (this.types = res as UnitsModel[]));
    this.ingredientsService = new IngredientsService(this.http, this.envUrl);
    this.ingredientsService
      .list()
      .subscribe((res) => (this.ingredients = res as IngredientModel[]));
  }

  ngAfterViewInit() {
    if (this.id > 0) {
      this.resibesService?.get(this.id).subscribe((at) => {
        this.data = at as RecipeModel;
        if (this.data.category != null) this.categoryId = this.data.category.id;
        this.data.ingredients.forEach((r) => (r.isEditing = false));
        this.changeDetectorRef.detectChanges();
      });
    }
  }

  Save(): void {
    var resData: RecipeCreateUpdateModel;

    resData = {
      id: -1,
      name: '',
      description: '',
      endDescription: '',
      servings: 0,
      servings2: 0,
      servingsNode: '',
      oventimeS: 0,
      timeSpentInKichenS: 0,
      cooktimeS: 0,
      totalTimeS: 0,
      categoryId: 0,
      ingredients: [],
    };

    resData.description = this.data.description;
    resData.endDescription = this.data.endDescription;
    resData.servings = this.data.servings;
    resData.servings2 = this.data.servings2;
    resData.servingsNode = this.data.servingsNode;
    resData.id = this.data.id;
    resData.name = this.data.name;
    resData.categoryId = this.categoryId;
    resData.cooktimeS = this.data.cooktimeS;
    resData.oventimeS = this.data.oventimeS;
    resData.timeSpentInKichenS = this.data.timeSpentInKichenS;
    resData.totalTimeS = this.data.totalTimeS;
    if (this.data.ingredients != null)
      this.data.ingredients.forEach((ingredient) => {
        resData.ingredients.push({
          ammount: ingredient.ammount,
          ammount2: ingredient.ammount2,
          unitId: ingredient.unit.id,
          ingredientId: ingredient.ingredient.id,
        });
      });

    if (this.id > 0) {
      this.resibesService?.update(this.id, resData).subscribe(() => {
        this.router.navigateByUrl('/recipes');
      });
    } else {
      this.resibesService?.create(resData).subscribe(() => {
        this.router.navigateByUrl('/recipes');
      });
    }
  }

  Cansle(): void {
    this.router.navigateByUrl('/recipes');
  }

  addRow(): void {
    if (this.data.ingredients == null) this.data.ingredients = [];
    const maxId = this.data?.ingredients.reduce(function (
      maxId: number,
      current: IngredientsModel,
    ) {
      return maxId > current.id ? maxId : current.id;
    }, 0);
    this.data?.ingredients.push({
      id: maxId + 1,
      ammount: 0,
      ammount2: 0,
      unit: { id: -1, unit: '' },
      ingredient: { id: -1, name: '' },
      isEditing: false,
    });
  }

  enableEditMode(row: IngredientsModel): void {
    // Store original data for cancel action
    row.originalData = { ...row };
    row.isEditing = true;
  }

  updateRow(row: IngredientsModel): void {
    // Exit edit mode
    row.isEditing = false;
    delete row.originalData; // Clean up temporary data
  }

  deleteEdit(row: IngredientsModel) {
    if (window.confirm($localize`Are sure you want to delete this item ${row.id}?`)) {
      this.data.ingredients = this.data.ingredients.filter((at) => {
        return at.id != row.id;
      });
      this.changeDetectorRef.detectChanges();
    }
  }

  cancelEdit(row: IngredientsModel): void {
    // Revert to original data
    Object.assign(row, row.originalData);
    row.isEditing = false;
    delete row.originalData; // Clean up
  }
}
